<template>
  <div class="login-page">
    <div class="wrapper wrapper-full-page">
      <div class="full-page section-image">
        <el-row justify="center" align="middle" class="login-frame">
          <el-col :md="8" :xs="24">
            <el-form :label-position="'left'" :class="shakeClass">
              <el-card class="login-card">
                <div class="logo">
                  <img
                    src="~img/logo/ss-logo-8-12-2021.svg"
                    alt="SendSquared"
                  />
                </div>
                <h2 class="mt-3" style="color: white; text-align: center">
                  Page Not Found
                </h2>
                <p style="color: white; text-align: center">
                  Oops! It seems that this page does not exist.
                  <br />You can navigate back
                  <router-link v-if="getLoginStatus" to="/"
                    >to the dashboard.</router-link
                  >
                  <router-link v-if="!getLoginStatus" to="/login"
                    >to login.</router-link
                  >
                </p>
              </el-card>
            </el-form>
          </el-col>
        </el-row>
        <app-footer></app-footer>
        <div class="full-page-background color-yellow"></div>
      </div>
    </div>
  </div>
</template>
<script>
import AppFooter from './../Dashboard/Views/Pages/Layout/AppFooter';
import { mapGetters } from 'vuex';
export default {
  components: {
    AppFooter,
  },
  computed: {
    ...mapGetters('auth', ['getLoginStatus']),
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    addLoginClass() {
      document.body.classList.add('drop-margin');
    },
    removeLoginClass() {
      document.body.classList.remove('drop-margin');
    },
  },
  created() {
    this.addLoginClass();
  },
  beforeUnmount() {
    this.removeLoginClass();
    this.closeMenu();
  },
};
</script>
<style lang="scss" scoped>
.logo {
  text-align: center;

  img {
    // width: 75%;
    margin: 0 auto;
    margin-bottom: 2em;
  }
}

.full-page-background {
  position: absolute;
  z-index: 1;
  height: 100vh;
  width: 100vw;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
  background-image: url('~img/background/jan-sendereks.jpg');
}

.login-frame {
  z-index: 4;
  height: 90vh;
}

.login-card {
  background-color: rgba(37, 36, 34, 0.85);
  border-color: rgba(37, 36, 34, 0.95);
}

.logo img {
  width: 230px;
  margin-top: 1em;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.status {
  color: red;
  text-align: center;
}
.el-input__inner {
  color: #222222;
}

.ahashakeheartache {
  animation: kf_shake 0.4s 1 linear;
}

@keyframes kf_shake {
  0% {
    transform: translate(30px);
  }

  20% {
    transform: translate(-30px);
  }

  40% {
    transform: translate(15px);
  }

  60% {
    transform: translate(-15px);
  }

  80% {
    transform: translate(8px);
  }

  100% {
    transform: translate(0px);
  }
}
</style>
